import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { modules } from 'veritone-redux-common';
const { auth, user, uiState, config } = modules;
const { namespace: userNamespace, reducer: userReducer } = user;
const { namespace: authNamespace, reducer: authReducer } = auth;

import appReducer, { namespace as appNamespace } from 'modules/app';
import folderReducer, { namespace as folderNamespace } from 'modules/app/folder';
import appSettingReducer, { namespace as appSettingNameSpace } from 'modules/app/appSetting'
import advertiserReducer, { namespace as advertiserNamespace } from 'modules/app/advertiser';
import campaignReducer, { namespace as campaignNamespace } from 'modules/app/campaign'
import notificationReducer, { namespace as notificationNamespace } from 'modules/app/notification';
import enginesExampleReducer, { namespace as enginesExampleNamespace } from 'modules/engines-example';
import mentionsReducer, { namespace as mentionNamespace } from 'modules/app/mentions';
import visualDataRefreshReducer, { namespace as visualDataRefreshNameSpace } from "modules/app/visualDataRefresh"
import filePickerReducer, { namespace as filePickerNamespace } from 'modules/filePicker';
import geoSelectorReducer, { namespace as GeoSelectorNameSpace } from './modules/app/geoSelector/reducer';
import dialogStatusReducer, { namespace as dialogStatusNamespace } from 'modules/app/dialogStatus/reducer';
import userManagementReducer, { namespace as userManagementNameSpace } from './modules/app/userManagement/reducer';
import orgManagementReducer, { namespace as orgManagementNameSpace } from './modules/app/orgManagement/reducer';
import searchReducer, {namespace as searchNameSpace} from './modules/app/search';
import marketReducer, { namespace as marketNameSpace } from './modules/app/market/reducer';
import trafficChannelReducer, { namespace as trafficChannelNameSpace } from './modules/app/trafficChannel/reducer';
import timeZoneReducer, { namespace as timeZoneNameSpace } from './modules/app/timeZone/reducer';
import creativeMappingReducer, { namespace as creativeMappingNameSpace } from './modules/app/creativeMapping/reducer';
import playoutReducer, { namespace as playoutReducerNameSpace } from './modules/app/playout/reducer';
import stationReducer, { namespace as stationReducerNamespace } from './modules/app/station/reducer';
import reportReducer, {namespace as reportReducerNamespace} from './modules/app/reportBuilder/reducer';
import scheduleReportReducer, { namespace as scheduleReportReducerNamespace } from './modules/app/scheduleReport/reducer';
import campaignErrorReducer, { namespace as campaignErrorReducerNamespace } from './modules/app/campaignError';
import emailTemplateReducer, {namespace as emailTemplateReducerNamespace } from './modules/app/emailTemplate';
import locationGranularityReducer, { namespace as locationGranularityNameSpace } from './modules/app/locationGranularity/reducer';
import featureFlagConfigReducer, { namespace as featureFlagNameSpace } from './modules/app/faetureFlagConfig/reducer';


export default extraReducers =>
  combineReducers({
    form: formReducer,
    [uiState.namespace]: uiState.reducer,
    [authNamespace]: authReducer,
    [appNamespace]: appReducer,
    [folderNamespace]: folderReducer,
    [appSettingNameSpace]: appSettingReducer,
    [advertiserNamespace]: advertiserReducer,
    [campaignNamespace]: campaignReducer,
    [notificationNamespace]: notificationReducer,
    [enginesExampleNamespace]: enginesExampleReducer,
    [userNamespace]: userReducer,
    [mentionNamespace]: mentionsReducer,
    [visualDataRefreshNameSpace]: visualDataRefreshReducer,
    [filePickerNamespace]: filePickerReducer,
    [config.namespace]: (state = window.config) => state, // fixme?
    [GeoSelectorNameSpace]: geoSelectorReducer,
    [dialogStatusNamespace]: dialogStatusReducer,
    [userManagementNameSpace]: userManagementReducer,
    [orgManagementNameSpace]: orgManagementReducer,
    [searchNameSpace]: searchReducer,
    [marketNameSpace]: marketReducer,
    [trafficChannelNameSpace]: trafficChannelReducer,
    [timeZoneNameSpace]: timeZoneReducer,
    [creativeMappingNameSpace] : creativeMappingReducer,
    [playoutReducerNameSpace]: playoutReducer,
    [stationReducerNamespace]: stationReducer,
    [reportReducerNamespace]: reportReducer,
    [scheduleReportReducerNamespace]: scheduleReportReducer,
    [campaignErrorReducerNamespace]: campaignErrorReducer,
    [emailTemplateReducerNamespace]: emailTemplateReducer,
    [locationGranularityNameSpace]: locationGranularityReducer,
    [featureFlagNameSpace]: featureFlagConfigReducer,
      ...extraReducers
  });
